// Названия и описания 1:1 с ref SUB_BLOCK_CONFIGS (designBlock.ts:115-172).
// Дизейбленных карточек «Скоро» здесь больше нет: последняя такая, `animation`,
// снята заказчиком 2026-07-29, а гейт исчерпанности ниже не даёт завести тип
// юниона без рендера и формы — то есть карточка без рабочего элемента невозможна.
import { Heading, Image as ImageIcon, Table, Tag, Type } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { DesignElementType } from '@/types/blocks'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

export interface DesignElementCard {
  type: DesignElementType
  label: string
  description: string
  icon: LucideIcon
}

/** Карточка на КАЖДЫЙ тип юниона — Record, а не массив: новый тип без карточки
 *  раньше просто не появлялся в палитре, и инвариант-тест проводки (он берёт
 *  кейсы отсюда же) переставал его замечать. Теперь это ошибка компиляции. */
type CardKey = 'cardHeading' | 'cardText' | 'cardImage' | 'cardBadge' | 'cardTable'

const CARD_BY_TYPE: Record<DesignElementType, { key: CardKey; icon: LucideIcon }> = {
  heading: { key: 'cardHeading', icon: Heading },
  text: { key: 'cardText', icon: Type },
  image: { key: 'cardImage', icon: ImageIcon },
  badge: { key: 'cardBadge', icon: Tag },
  table: { key: 'cardTable', icon: Table },
}

/** Порядок строк в палитре (1:1 с рефом) — отдельно от Record: порядок ключей
 *  объекта контрактом не является. */
type PaletteOrder = ['heading', 'text', 'image', 'badge', 'table']

/** Порядок обязан перечислять юнион целиком, иначе тип выпал бы из палитры молча. */
type OrderCoversUnion = [Exclude<DesignElementType, PaletteOrder[number]>] extends [never]
  ? true
  : 'в CARD_ORDER не хватает типа элемента'
const _orderCoversUnion: OrderCoversUnion = true

const CARD_ORDER: PaletteOrder = ['heading', 'text', 'image', 'badge', 'table']

/** Подписи — геттеры: читаются на рендере, на текущем языке интерфейса. */
export const DESIGN_ELEMENT_CARDS: DesignElementCard[] = CARD_ORDER.map((type) => {
  const { key, icon } = CARD_BY_TYPE[type]
  return {
    type,
    icon,
    get label() {
      return messagesNow(messages)[key]
    },
    get description() {
      return messagesNow(messages)[`${key}Desc` as const]
    },
  }
})
